const FilterValue = {
  OFF: 'off',
} as const;

export { FilterValue };
